import React, { Component } from 'react';

import { ClipLoader } from 'react-spinners';

export default class Spinner extends Component {
  render() 
  {
    return (
      <ClipLoader
        size={30}
        color={this.props.color}
        loading={true}
      />
    );
  }
}
